import styled from "styled-components"

export const AboutSection = styled.div`
  p {
    line-height: 30px;
  }
`
